module.exports = __webpack_public_path__ + "static/media/04_custom_power_supply_cable.5645afd6.jpg";